import tripEventsSaga from './tripEventsSaga';

export default tripEventsSaga;
